import React from 'react';
import { ReviewModal } from './review-modal.component';
import { ReviewedModal } from './reviewed-modal.component';
import { useReviewModalService } from './review-modal.service';
import type { ReviewModalContainerProps } from './review-modal.types';

export const ReviewModalContainer = (props: ReviewModalContainerProps) => {
  const {
    isReviewed,
    existingReview,
    onCancel,
    ...reviewFormProps
  } = useReviewModalService(props);

  // If lesson is already reviewed, show read-only view
  if (isReviewed && existingReview) {
    return (
      <ReviewedModal
        totalSatisfaction={existingReview.total_satisfaction}
        audioQuality={existingReview.audio_quality}
        reviewText={existingReview.review}
        onClose={onCancel}
      />
    );
  }

  // Show review form
  return (
    <ReviewModal
      {...reviewFormProps}
      onCancel={onCancel}
    />
  );
};
